<template>
  <div style="background-color: rgba(236, 243, 255, 1);">
    <HeadVue></HeadVue>
    <!-- 顶部banner -->
    <section class="banner" style="margin-top: 60px">
      <div class="container">
        <div style="margin-right: 358px">
          <h1 class="title">应需而生</h1>
          <p class="title-desc">管理可无限贴近业务 而无需受限于管理工具。基于PaaS平台可以低成本构建ERP、</p>
          <p class="title-desc" style="text-align: left">WMS、SCM、OA、CRM 、PLM、MES 、APS等企业级应用，实现供应链协同</p>
        </div>
        <div class="crystal-ball">
          <div class="crystal-item">
            <span>配置足够灵活</span>
          </div>
          <div class="crystal-item">
            <span>低代码+PaaS+SaaS</span>
          </div>
          <div class="crystal-item">
            <span>数字化转型成本低</span>
          </div>
          <div class="crystal-item">
            <span>支持OPC UA等工业协议</span>
          </div>
        </div>
        <div class="wave"></div>
      </div>
    </section>

    <!-- 流程图 -->
    <section class="process">
      <div style="display: flex;justify-content: center;margin-top: 55px;margin-bottom: 88px">
        <h2 class="section-title">从想法到现实，只需轻松几步</h2>
      </div>

      <div class="container">
        <div class="process-items">
          <div class="process-item">
            <div class="icon">
              01
            </div>
            <p class="desc"> 业务蓝图设计</p>
          </div>
          <div class="process-item">
            <div class="icon">
              02
            </div>
            <p class="desc"> 实体设计</p>
          </div>
          <div class="process-item">
            <div class="icon">
              03
            </div>
            <p class="desc"> 应用创建</p>
          </div>
          <div class="process-item">
            <div class="icon">
              04
            </div>
            <p class="desc"> 模型设计</p>
          </div>
          <div class="process-item">
            <div class="icon">
              05
            </div>
            <p class="desc"> 页面设计</p>
          </div>
          <div class="process-item">
            <div class="icon">
              06
            </div>
            <p class="desc"> 逻辑编排</p>
          </div>
          <div class="process-item">
            <div class="icon">
              07
            </div>
            <p class="desc"> 现场测试</p>
          </div>
          <div class="process-item">
            <div class="icon">
              08
            </div>
            <p class="desc"> 应用发布</p>
          </div>
          <div class="process-item">
            <div class="icon">
              09
            </div>
            <p class="desc"> 菜单集成</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 优势展示 -->
    <section class="advantages">
      <div style="display: flex;justify-content: center;">
        <h2 class="section-title">用低代码的方式实现自由开发</h2>
      </div>
      <div class="container">
        <div class="advantage-grid">
          <div class="advantage-item" v-for="item in advantageList" :key="item.id">
            <div class="icon">
              <img src="./assets/img/fangkuai.png">
            </div>
            <h3>{{item.title}}</h3>
            <p>{{item.desc}}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 技术特点 -->
    <section class="features">
      <div style="display: flex;justify-content: center;">
        <h2 class="section-title">我们的优势</h2>
      </div>
      <div class="container">
        <div class="feature-list">
          <div class="feature-item" v-for="item in featureList" :key="item.id">
            <div class="feature-item-top">{{item.title}}</div>
            <div class="feature-item-bottom">
              {{item.desc}}
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 企业实力展示 -->
    <section class="enterprise">
      <div style="display: flex;justify-content: center;">
        <h2 class="section-title">企业数字化研发底座，为数字化转型加速</h2>
      </div>
      <div class="container">
        <div class="enterprise-grid">
          <div class="enterprise-item" v-for="item in enterpriseList" :key="item.id" :style="{backgroundImage: `url(${item.imgUrl})`}">
            <h3>{{item.title}}</h3>
            <p style="text-align: justify">{{item.desc}}</p>
          </div>
          <div class="enterprise-item-last">
            <div>
              <h3>经验积累共享</h3>
              <p>成熟的业务经验进行沉淀形成应用模板，可以在多个项目中快速复用与独立拓展。同时，也可以获取借鉴应用市场上的其他应用模板或将自己的经验共享给他人</p>
            </div>
            <div style="padding-right: 5px">
              <h3>信息安全</h3>
              <p>安全可信的开发环境，严格的租户数据隔离，稳定的服务环境，为业务应用安全保驾护航</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 资源调度 -->
    <section class="resource">
      <div style="display: flex;justify-content: center;">
        <h2 class="section-title">灵活搭建企业应用</h2>
      </div>
      <div class="container">
        <div class="resource-wrapper">
          <aside class="sidebar">
            <nav>
              <ul>
                <li
                    class="active"
                    v-for="item in resourceList"
                    :key="item.id"
                    :class="{resourceActive: item.id == resourceActive}"
                    @click="handleRresourceActive(item.id)"
                >
                  <div class="icon">
                    <img :src="item.id == resourceActive? item.imgActive: item.img">
                  </div>
                  <div class="active-title" style="vertical-align: top">{{item.title}}</div>
                </li>
              </ul>
            </nav>
          </aside>
          <main class="content">
            <div class="resource-chart">
              <h3>{{resourceChartTitle}}</h3>
              <p>{{resourceChartDesc}}</p>
              <div class="icon">
                <img :src="resourceActiveBanner">
              </div>
            </div>
          </main>
        </div>
      </div>
    </section>

    <!-- 快速通道 -->
    <section class="quick-access">
      <div style="display: flex;justify-content: center;">
        <h2 class="section-title">快速搭建，开启高效开发之旅</h2>
      </div>
      <div class="container">
        <div class="table-wrapper">
          <img src="./assets/img/quick-access-table.png">
        </div>
      </div>
    </section>

    <FooterVue style="margin-top: 0"></FooterVue>

  </div>

</template>
<script>
import HeadVue from "@/views/common/HeadVue.vue";
import FooterVue from "@/views/common/FooterVue.vue";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "index",
  components: {FooterVue, HeadVue},
  metaInfo: {
    title: '滁州人工智能-明晟智能科技有限公司',
    meta: [
      { name: 'description', content: '明晟智能科技有限公司是专注于垂直领域大语言模型技术创新的领军企业，致力于将智能科技深度融入高等教育、政务管理、医疗健康及新能源等多元领域' },
      { property: 'og:type', content: 'webpage' },
      { property: 'og:title', content: '滁州人工智能-明晟智能科技有限公司' },
      { property: 'og:description', content: '明晟智能科技有限公司是专注于垂直领域大语言模型技术创新的领军企业，致力于将智能科技深度融入高等教育、政务管理、医疗健康及新能源等多元领域' },
      { property: 'og:url', content: 'https://minsun-ai.com/' },
      { name: 'Keywords',content: "明晟智能科技有限公司,明晟,明晟智能,滁州人工智能,人工智能,AI,明晟大模型,明晟工业大模型"}
    ]
  },
  data(){
    return{
      resourceActive: 1,
      advantageList:[
        {
          id: 1,
          title:'所见即所得',
          desc: '拖拽组件，简单配置即可完成大多数应用场景。所见即所得降低配置难度'
        },
        {
          id: 2,
          title:'业务组件丰富',
          desc: '页面组件、规则组件、模型组件、逻辑服务组件四大类组件，涵盖交互场景，逻辑处理及服务能力，帮助应用搭建'
        },
        {
          id: 3,
          title:'模块引擎快捷生成',
          desc: '常用的功能形成固有模板，帮助用户完成重复的，有规律的应用搭建，简化搭建流程'
        },
        {
          id: 4,
          title:'业务规则随心定制',
          desc: '支持丰富、灵活的应用业务逻辑定义和控制能力，不同类型的基础能力都以逻辑节点的形式提供，完成更全面的信息体系搭建'
        },
        {
          id: 5,
          title:'多维度数据权限管控',
          desc: '用户自定义数据权限管控维度，并可以将数据权限方便的集成到配置出的功能中，解决实际应用场景中复杂的数据权限管控难题'
        },
        {
          id: 6,
          title:'应用版本低成本升级',
          desc: '所有组件均支持更新迭代，且不影响运行版本，满足不断变化的业务需求，破解SaaS应用相应需求成本偏高的难题'
        },
        {
          id: 7,
          title:'支持OPC UA信息模型',
          desc: '逻辑节点支持连接OPC UA服务器，调用OPC UA信息模型，完成数据的监控，节点数据的修改以及更复杂的工艺数据下发'
        },
        {
          id: 8,
          title:'租户间数据自由交换',
          desc: '租户间通过“握手”的方式获取数据权限后，可以根据权限开放数据。获取到对方数据后，可自定义数据处理逻辑，完成任意业务场景上下游的数据对接'
        }
      ],
      featureList:[
        {
          id: 1,
          title:'配置简单灵活',
          desc: '拖拽式页面构建，简单易用的数据建模，灵活可视化积木式的逻辑编排，极大缩短了应用创建周期'
        },
        {
          id: 2,
          title:'应用构建发布',
          desc: '完善的应用打包、升级、菜单集成能力，高效的团队协同开发能力，支持现场测试，大幅减少环境部署时间和成本，支撑大型企业级应用构建'
        },
        {
          id: 3,
          title:'资产兼容互补',
          desc: '强大的第三方集成能力，实现与现有系统数据互通；SaaS化可以快速实现与其他企业间在云平台中的数据互通'
        },
        {
          id: 4,
          title:'经验积累共享',
          desc: '成熟的业务经验进行沉淀形成应用模板，可在多个项目中快速复用与独立拓展。同时也可以将自己的经验共享给他人'
        },
        {
          id: 5,
          title:'信息安全',
          desc: '安全可信的开发环境，严格的租户数据隔离，稳定的服务环境，为业务应用安全保驾护航'
        },
      ],
      enterpriseList:[
        {
          id:1,
          imgUrl: require('./assets/img/banner3.png'),
          title:'配置简单灵活',
          desc:'拖拽式页面构建，简单易用的数据建模，灵活可视化积木式的逻辑编排，极大缩短了应用创建周期'
        },
        {
          id:2,
          imgUrl: require('./assets/img/banner4.png'),
          title:'应用构建发布',
          desc:'完善的应用打包、升级、菜单集成能力，高效的团队协同开发能力，支持现场测试，大幅减少环境部署时间和成本，支撑大型企业级应用构建'
        },
        {
          id:3,
          imgUrl: require('./assets/img/banner5.png'),
          title:'资产兼容互补',
          desc:'强大的第三方集成能力，实现与现有系统数据互通；SaaS化可以快速实现与其他企业间在云平台中的数据互通'
        },
        // {
        //   id:4,
        //   imgUrl: require('./assets/img/banner5.png'),
        //   title:'资产兼容互补',
        //   desc:'强大的第三方集成能力，实现与现有系统数据互通；SaaS化可以快速实现与其他企业间在云平台中的数据互通'
        // },
      ],
      resourceActiveBanner: require( './assets/img/resourceBanner1.png'),
      resourceList:[
        {
          id:1,
          img: require('./assets/img/resource1.png'),
          imgActive: require('./assets/img/resourceActive1.png'),
          title:'自定义页面',
          desc: '丰富的页面组件、为业务的多样性提供更多可能、提高业务的可操作性和用户体验'
        },
        {
          id:2,
          img: require('./assets/img/resource2.png'),
          imgActive: require('./assets/img/resourceActive2.png'),
          title:'流程引擎',
          desc: '审批表单、流程引擎和审批中心，满足企业的审批需求'
        },
        {
          id:3,
          img: require('./assets/img/resource3.png'),
          imgActive: require('./assets/img/resourceActive3.png'),
          title:'逻辑服务',
          desc: '丰富和颗粒度较低的节点，积木式实现业务逻辑的自由拼装'
        },{
          id:4,
          img: require('./assets/img/resource4.png'),
          imgActive: require('./assets/img/resourceActive4.png'),
          title:'模型驱动',
          desc: '模型驱动为业务灵活性打下基础，并且结构化的数据便于数据分析'
        },{
          id:5,
          img: require('./assets/img/resource5.png'),
          imgActive: require('./assets/img/resourceActive5.png'),
          title:'资源集成与应用管理',
          desc: '开发项目式管理应用资源，应用隔离'
        },{
          id:6,
          img: require('./assets/img/resource6.png'),
          imgActive: require('./assets/img/resourceActive6.png'),
          title:'开放API',
          desc: 'API配置，可以自由实现与外部系统的数据互通'
        },{
          id:7,
          img: require('./assets/img/resource7.png'),
          imgActive: require('./assets/img/resourceActive7.png'),
          title:'报表中心',
          desc: '提供报表构建介绍，和丰富的可视化图表，掌握企业经营情况'
        },{
          id:8,
          img: require('./assets/img/resource8.png'),
          imgActive: require('./assets/img/resourceActive8.png'),
          title:'权限管理',
          desc: '提供功能权限和数据权限，满足企业管理的权限需求'
        },{
          id:9,
          img: require('./assets/img/resource9.png'),
          imgActive: require('./assets/img/resourceActive9.png'),
          title:'业财一体化',
          desc: '系统无缝衔接，数据贯通，业财高效协同'
        },{
          id:10,
          img: require('./assets/img/resource10.png'),
          imgActive: require('./assets/img/resourceActive10.png'),
          title:'数据中心与AI服务',
          desc: '构建数据中心和大模型，用AI赋能企业'
        },
      ],
      resourceChartTitle:'自定义页面',
      resourceChartDesc:'丰富的页面组件、为业务的多样性提供更多可能、提高业务的可操作性和用户体验',
    }
  },
  methods: {
    handleRresourceActive(id){
      this.resourceActive = id
      let obj = this.resourceList.find(item => item.id == id)
      this.resourceChartTitle = obj.title
      this.resourceChartDesc = obj.desc
      this.resourceActiveBanner = require( `./assets/img/resourceBanner${id}.png`)
    },
    handleMouseEnter(id) {
      this.resourceActive = id
    },
    handleMouseLeave() {
      this.resourceActive = ''
    }
  }
}
</script>
<style scoped lang="css">
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  body {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
    line-height: 1.6;
    color: #333;
  }

  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 15px;
  }
  .section-title {
    font-size: 32px;
    color: #181F5C;
    margin-bottom: 20px;
    position: relative;
    text-align: center;
    font-family: "Alimama ShuHeiTi-Bold";
  }
  .section-title:before{
    left: -135px !important;
  }
 .section-title:after{
    right: -135px !important;
  }

  .process .container {
    height: 248px;
    position: relative;
    left: 0;
    top: 0;
    width: 100%;
    margin: 0 auto;
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% 248px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    background-image:  url("./assets/img/process.png");
  }
  .section-title:before {
    content: "";
    background-image: url('assets/img/title-icon-left.png');
    position: absolute;
    width: 112px;
    height: 59px;
    //background-color: #0052d9;
    bottom: -10px;

    //transform: translateX(-50%);
  }
  .section-title:after {
    content: "";
    background-image: url('assets/img/title-icon-right.png');
    position: absolute;
    width: 112px;
    height: 59px;
    //background-color: #0052d9;
    bottom: -10px;
    right: 185px;
    //transform: translateX(-50%);
  }
  /* Banner样式 */
  .banner {
    height: 600px;
    position: relative;
    left: 0;
    top: 0;
    width: 100%;
    margin: 0 auto;
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% 600px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    background-image:  url("./assets/img/banner.png");
  }
  .title{
    background-image: linear-gradient(45deg, rgba(7, 103, 252, 1) 0, rgba(22, 237, 140, 1) 100%);
    width: 205px;
    height: 56px;
    overflow-wrap: break-word;
    font-size: 50px;
    font-family: Alimama ShuHeiTi-Bold;
    font-weight: 700;
    text-align: left;
    white-space: nowrap;
    line-height: 56px;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    margin-bottom: 20px;
  }
  .title-desc {
    font-size: 22px;
    color: #333333;
  }
  .banner .crystal-ball {
    //width: 200px;
    //height: 200px;
    display: flex;
    position: absolute;
    bottom: -40px;
  }
  .crystal-item{
    width: 264px;
    height: 80px;
    background: #c8e7ff;
    border-radius: 8px 8px 8px 8px;
    border: 1px solid #FFFFFF;
    margin-left: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 22px;
    color: #181F5C;
    font-weight: 700;
    font-family: "Alimama ShuHeiTi-Bold";
  }
  .banner .wave {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100px;

  }

  /* 流程图样式 */
  .process {
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100% 604px;
    background-image:  url("./assets/img/banner2.png");
    padding: 10px 0;
    height: 604px;
  }

  .process-items {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    position: relative;
    width: 100%;
  }
  .process-items .process-item {
    position: absolute;
    text-align: center;
  }
  .process-items .process-item .icon {
    background-image: linear-gradient(35deg, rgba(7,103,252,0) 0%, rgba(7,103,252,0.4) 100%);;
    width: 60px;
    overflow-wrap: break-word;
    font-size: 50px;
    //font-family: Alimama ShuHeiTi-Bold;
    font-weight: 700;
    text-align: left;
    white-space: nowrap;
    line-height: 56px;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  .process-items .process-item:nth-child(1) {
    //flex: 1;
    top: 125px;
  }
  .process-items .process-item:nth-child(2) {
    //flex: 1;
    bottom: 135px;
    left: 142px;
  }
  .process-items .process-item:nth-child(3) {
    //flex: 1;
    top: 125px;
    left: 283px;
  }
  .process-items .process-item:nth-child(4) {
    //flex: 1;
    bottom: 135px;
    left: 428px;
  }
  .process-items .process-item:nth-child(5) {
    //flex: 1;
    top: 125px;
    left: 559px;
  }
  .process-items .process-item:nth-child(6) {
    //flex: 1;
    bottom: 135px;
    left: 691px;
  }
  .process-items .process-item:nth-child(7) {
    //flex: 1;
    top: 125px;
    left: 842px;
  }
  .process-items .process-item:nth-child(8) {
    //flex: 1;
    bottom: 135px;
    left: 974px;
  }
  .process-items .process-item:nth-child(9) {
    //flex: 1;
    top: 125px;
    left: 1115px;
  }
  .process-item .desc{
    position: absolute;
    font-size: 24px;
    color: #333333;
    font-weight: 700;
    font-family: Alimama ShuHeiTi-Bold;
    left: -50px;
    bottom: -5px;
    width: 150px;
  }

  /* 优势展示样式 */
  .advantages {
    //background: #f8f9fa;
    padding: 60px 0;
  }

  .advantage-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 30px;
    margin-top: 20px;
  }

  .advantage-item {
    width: 285px;
    height: 368px;
    background:  #FFFFFF;
    border-radius: 10px 10px 10px 10px;
    border: 1px solid #FFFFFF;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .advantage-item .icon {
    padding: 20px;
  }
  .advantage-item h3 {
    font-size: 24px;
    color: #333333;
    font-family: "Alimama ShuHeiTi-Bold";
  }
  .advantage-item p {
    font-size: 20px;
    color: #333333;
    padding: 20px;
    text-align: justify;
  }
  .feature-list{
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 30px;
    margin-top: 20px;
  }
  .feature-item{

  }
  .feature-item-top{
    width: 590px;
    height: 50px;
    background: linear-gradient( 45deg, #0767FC 0%, rgba(7,103,252,0) 100%);
    border-radius: 0px 0px 0px 0px;
    font-size: 24px;
    color: #FFFFFF;
    font-weight: 700;
    line-height: 50px;
    padding-left: 20px;
  }
  .feature-item-bottom{
    width: 590px;
    height: 142px;
    background: linear-gradient( 180deg, #ECF1F9 0%, #FEFEFF 100%);
    border-radius: 0px 0px 0px 0px;
    border: 1px solid #FFFFFF;
    font-weight: 400;
    font-size: 20px;
    color: #333333;
    padding: 20px;
  }
  /* 企业实力样式 */
  .enterprise {
    padding: 60px 0;
  }

  .enterprise-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 1px;
    margin-top: 20px;
  }
  .enterprise-item-last{
    display: flex;
  }
  .enterprise-item-last div:nth-child(1){
    width: 298px;
    height: 282px;
    border-radius: 0px 0px 0px 0px;
    background-image:  url("./assets/img/banner6.png");
    margin-right: 1px;
    padding: 20px;
  }
  .enterprise-item-last div:nth-child(2){
    width: 298px;
    height: 282px;
    border-radius: 0px 0px 0px 0px;
    background-image:  url("./assets/img/banner7.png");
    margin-right: 1px;
    padding: 20px;
  }
  .enterprise-item-last div h3{
    font-weight: 700;
    font-size: 24px;
    color: #FFFFFF;
    font-family: "Alimama ShuHeiTi-Bold";
  }
  .enterprise-item-last div p{
    font-weight: 400;
    font-size: 20px;
    color: #FFFFFF;
    margin-top: 20px;
  }
  .enterprise-item {
    position: relative;
    width: 602px;
    height: 282px;
    border-radius: 0px 0px 0px 0px;
    background-repeat: no-repeat;
    background-position: center;
    //background-size: 100% 604px;
    //background-image:  url("./assets/img/banner3.png");
    padding: 50px;
    background-size: 100% 100%;
  }
  .enterprise-item:nth-child(2) {
    width: 597px !important;
  }
  .enterprise-item  h3{
    font-weight: 700;
    font-size: 24px;
    color: #FFFFFF;
    font-family: "Alimama ShuHeiTi-Bold";
  }
  .enterprise-item p{
    font-weight: 400;
    font-size: 20px;
    color: #FFFFFF;
    margin-top: 20px;
  }
  /* 资源调度样式 */
  .resource {
    //background: #f8f9fa;
    //padding: 60px 0;
  }

  .resource-wrapper {
    display: flex;
    //gap: 30px;
    margin-top: 20px;
  }
  .resource-chart {
    padding: 20px;
    margin-top: 30px;
  }
  .resource-chart h3{
    font-weight: 700;
    font-size: 28px;
    color: #333333;
    font-family: "Alimama ShuHeiTi-Bold";
    margin-bottom: 20px;
  }
  .resource-chart p{
    font-size: 22px;
    color: #333333;
    margin-bottom: 50px;
  }
  .resource-chart .icon img{
    width: 800px;
    height: 539px;
  }
  .sidebar {
    background: #fff;
    //border-radius: 8px;
    //padding: 30px;
    width: 279px;
    height: 776px;
    background: rgba(7,103,252,0.1);
    border-radius: 0px 0px 0px 0px;
    padding-top: 20px;
    cursor: pointer;

  }
  .active div:nth-child(2){
    font-size: 18px;
    color: #333333;
    //margin-bottom: 5px;
  }
  .sidebar .active{
    width: 279px;
    height: 66px;
    display: flex;
    padding: 30px;
    align-items: center;
    margin-bottom: 10px;
  }
  .sidebar .active:hover{
    width: 279px;
    height: 66px;
    background: #ffffff4d
  }
  .sidebar .active:hover .active-title{
    color: #165dff;
  }
  .resourceActive{
    background: #0767FC !important;

  }
  .resourceActive .active-title{
    color: #FFFFFF !important;
  }
  .sidebar .icon {
    margin-right: 5px;
  }

  .sidebar .icon img{
    width: 24px;
    height: 24px;
  }
  .content {
    flex: 1;
    background: #fff;
    //border-radius: 8px;
    padding: 20px;
    width: 908px;
    height: 776px;
    background: rgba(7,103,252,0.05);
    border-radius: 0px 0px 0px 0px;
  }

  /* 快速通道样式 */
  .quick-access {
    padding: 60px 0;
  }

  .table-wrapper {
    //overflow-x: auto;
    margin-top: 30px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
  }

  th, td {
    padding: 12px;
    border: 1px solid #eee;
    text-align: left;
  }

  /* 页脚样式 */
  footer {
    background: #0066cc;
    color: #fff;
    padding: 40px 0;
  }

  .footer-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .qr-code img {
    width: 120px;
    height: 120px;
  }


</style>